import React from 'react';

/**
 * Badge Component - 2025 Design System (iOS/Linear-style)
 *
 * Production-grade badge with:
 * - Pill shape (fully rounded)
 * - Subtle borders
 * - Semantic colors
 * - Compact padding
 */

export const Badge = ({ children, className = '', variant = 'default', ...props }) => {
  const variants = {
    default: 'bg-gray-100 text-gray-800 border-gray-300',
    primary: 'bg-blue-100 text-blue-800 border-blue-300',
    success: 'bg-green-100 text-green-800 border-green-300',
    warning: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    danger: 'bg-red-100 text-red-800 border-red-300',
    info: 'bg-indigo-100 text-indigo-800 border-indigo-300',
  };

  return (
    <span
      className={`
        inline-flex
        items-center
        px-2.5
        py-0.5
        rounded-full
        text-xs
        font-medium
        border
        ${variants[variant] || ''}
        ${className}
      `}
      {...props}
    >
      {children}
    </span>
  );
};
